import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { dealsAPI, clientsAPI } from '../../lib/api';
import api from '../../lib/api';
import { toast } from 'sonner';

const Deals = () => {
  const [deals, setDeals] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [dealsRes, clientsRes] = await Promise.all([
        dealsAPI.getAll(),
        clientsAPI.getAll()
      ]);
      setDeals(dealsRes.data);
      setClients(clientsRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const getClientName = (clientId) => {
    const client = clients.find(c => c.id === clientId);
    return client?.name || '-';
  };

  const columns = [
    { key: 'name', label: 'Deal Name' },
    { key: 'client_id', label: 'Client', render: (val) => getClientName(val) },
    { key: 'value', label: 'Value', type: 'currency' },
    { key: 'probability', label: 'Probability', type: 'percentage' },
    { key: 'expected_close', label: 'Expected Close', type: 'date' },
    { key: 'stage', label: 'Stage', type: 'status' },
  ];

  const formFields = [
    { name: 'name', label: 'Deal Name', required: true, placeholder: 'Enter deal name' },
    {
      name: 'client_id',
      label: 'Client',
      type: 'select',
      options: clients.map(c => ({ value: c.id, label: c.name })),
    },
    { name: 'value', label: 'Deal Value', type: 'number', defaultValue: 0 },
    { name: 'probability', label: 'Probability (%)', type: 'number', defaultValue: 20 },
    { name: 'expected_close', label: 'Expected Close Date', type: 'date' },
    {
      name: 'stage',
      label: 'Stage',
      type: 'select',
      defaultValue: 'qualification',
      options: [
        { value: 'qualification', label: 'Qualification' },
        { value: 'proposal', label: 'Proposal' },
        { value: 'negotiation', label: 'Negotiation' },
        { value: 'closed_won', label: 'Closed Won' },
        { value: 'closed_lost', label: 'Closed Lost' },
      ],
    },
  ];

  const handleAdd = async (data) => {
    await dealsAPI.create(data);
    fetchData();
  };

  const handleEdit = async (id, data) => {
    await dealsAPI.update(id, data);
    fetchData();
  };

  const handleCreateQuotation = async (deal) => {
    try {
      const value = Number(deal.value || 0);
      const dealName = deal.title || deal.name || "Deal items";
      const payload = { client_id: deal.client_id, status: "draft", items: [{ description: dealName, quantity: 1, unit_price: value, tax_rate: 0, subtotal: value, tax_amount: 0 }], subtotal: value, tax_rate: 0, tax: 0, total: value, notes: "Created from deal: " + dealName, reference: deal.id };
      await api.post("/quotations", payload);
      toast.success("Draft quotation created for this deal");
    } catch (error) {
      toast.error("Failed to create quotation");
    }
  };

  const handleDelete = async (id) => {
    await dealsAPI.delete(id);
    fetchData();
  };

  return (
    <DataTable
      title="Deals"
      description="Manage your sales pipeline"
      data={deals}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
        customActions={[{ label: 'Create Quotation', hidden: (item) => item.stage === 'closed_lost' || item.stage === 'lost', onClick: (item) => handleCreateQuotation(item) }]}
    />
  );
};

export default Deals;
